import { Type } from '@deqo/foundation';
import { injectable } from 'inversify';
import { Component } from '../../../concepts/objects';
import { LibraryBase } from '../../canvas/LibraryBase';
import { Activator, Connector } from '../../Container';
import { ExportDimensionType } from './ExportDimension';

export interface ExportAdapter {
    readonly id: string;
    readonly label: string;
    readonly priority: number;
    readonly defaults?: boolean;
    query(rows: Component[]): ExportDimensionType[];
}

export class ExportAdapterLibrary extends LibraryBase<ExportAdapter> {
    protected index = (item: ExportAdapter) => item.id;
}

export const inExportAdapter = (type: Type<ExportAdapter>) => Connector(r => {
    const activator = r.call(Activator);
    const library = r.call(ExportAdapterLibrary);
    library.register(activator.call(type));
});

@injectable()
export abstract class FromFirstMatchExportAdapter implements ExportAdapter {

    public readonly priority = 20 as number;

    public abstract get id(): string;
    public abstract get label(): string;
    public abstract get columns(): ExportDimensionType[];

    protected abstract selector(c: Component): boolean;

    public query(rows: Component[]): ExportDimensionType[] {
        const hit = rows.find(x => this.selector(x));
        return hit ? this.columns : [];
    }
}


